import { useAuthStore } from '@/features/auth/useAuthStore';
import { Layout } from '@/features/dashboard/layout/Layout'
import { createFileRoute, redirect } from '@tanstack/react-router'


export const Route = createFileRoute('/_dashboard')({
  beforeLoad: async ({ location }) => {
    const authStore = useAuthStore.getState();
    await authStore.verifyLogin();
    
    // billing_viewer ロールの場合、請求関連画面以外はアクセス禁止
    if (authStore.adminRole === 'billing_viewer') {
      const allowedPaths = ['/billing', '/billing-management', '/call-details'];
      if (!allowedPaths.includes(location.pathname)) {
        throw redirect({ to: '/billing' });
      }
    }

    // admin ロールの場合、請求関連画面はアクセス禁止
    if (authStore.adminRole === 'admin') {
      const restrictedPaths = ['/billing', '/billing-management', '/call-details'];
      if (restrictedPaths.includes(location.pathname)) {
        throw redirect({ to: '/' });
      }
    }
  },
  component: Layout
});
